/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConfigSpec } from './configSpec';


/**
 * The list of successful saved and failed configs.
 */
export interface ConfigsSaveResponse { 
    saved_configs?: Array<ConfigSpec>;
    failed_configs?: Array<ConfigSpec>;
}

